<div *ngIf="maintenance$ | async as maintenance" class="maintenance-alert-container">
  <div *ngIf="maintenance?.isActive" class="maintenance-alert">
    <mat-icon svgIcon="info-16"></mat-icon>
    <div class="message" [innerHTML]="maintenance?.message"></div>
  </div>
</div>
